import { Skeleton } from "@/shared/components/ui/skeleton";

function RowSkeleton() {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <div className="flex items-center gap-3">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-5 w-20" />
      </div>
      <Skeleton className="mt-3 h-4 w-full" />
      <Skeleton className="mt-2 h-4 w-2/3" />
    </div>
  );
}

export function FeatureFlagsListSkeleton() {
  // Mirror the grouped layout (section eyebrow + rows, space-y-8) so there's
  // no layout shift on the loading → loaded transition.
  return (
    <div data-testid="feature-flags-list-loading" className="space-y-8">
      {Array.from({ length: 2 }).map((_, group) => (
        <div key={group} className="space-y-3">
          <Skeleton className="h-4 w-28" />
          {Array.from({ length: 2 }).map((_, row) => (
            <RowSkeleton key={row} />
          ))}
        </div>
      ))}
    </div>
  );
}
